import * as React from 'react';
import styled, {css} from 'styled-components'
import {
    ConstBreakPoint,
    ConstColor,
    ConstFontStyle,
    ConstFontWeight,
    ConstMargin
} from "../../../../config/styles_const/styles_const";
import {Link, LinkProps} from "react-router-dom";

interface IProps
    extends LinkProps {
    icon?: string;
    iconPrefix?: "900" | "400" | "300"; // fontawesom solid 900 regular 400 light 300
    bold?: boolean;
    defaultMargin?: boolean;
}

const ParagraphLinkDefault: React.FC<IProps> = (props) => {

    const { icon, bold, defaultMargin, iconPrefix, children, ...LProps } = props;

    return<Link {...LProps}>{children}</Link>;

};

const ParagraphLink = styled(ParagraphLinkDefault)`
    color: ${ConstColor.Base};
    font-style: normal;
    font-weight: ${props => props.bold ? ConstFontWeight.BOLD : ConstFontStyle.SpParagraphDefault.fontWeight};
    font-size: ${ConstFontStyle.SpParagraphDefault.fontSize};
    line-height: ${ConstFontStyle.SpParagraphDefault.lineHeight};
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        font-weight: ${props => props.bold ? ConstFontWeight.BOLD : ConstFontStyle.ParagraphDefault.fontWeight};
        font-size: ${ConstFontStyle.ParagraphDefault.fontSize};
        line-height: ${ConstFontStyle.ParagraphDefault.lineHeight};
    }
    
    ${props => props.defaultMargin && css`
        margin-bottom: ${ConstMargin.SpParagraphBottom};
        @media screen and (min-width: ${ConstBreakPoint.Default}) {
            margin-bottom: ${ConstMargin.ParagraphBottom};
        }
    `}    
    ${props => props.icon && css`
        ::before {
            margin-right: ${ConstMargin.ParagraphIconRight};
            content: ${props.icon};
            font-family: "Font Awesome 5 Free";
            font-weight: ${props.iconPrefix ? props.iconPrefix : "900"};
        }
    `}
`;

export default ParagraphLink;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/text/paragraph_link.tsx